/** Odometer-style rolling number — mirrors the mobile SplitFlapNumber. Each digit
 *  is a clipped column of 0–9 that translates to the target; CSS transitions the
 *  roll whenever the value changes. Non-digits render static. */
interface Props {
  value: string;
  /** Number = px. String = any CSS length, e.g. "6em". */
  size?: number | string;
  color?: string;
  weight?: number;
}

const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

function Digit({ d }: { d: number }) {
  return (
    <span className="cell" style={{ height: "1em", width: "0.65em" }}>
      <span className="roll" style={{ transform: `translateY(${-d}em)` }}>
        {DIGITS.map((n) => (
          <span key={n} style={{ height: "1em", lineHeight: "1em" }}>
            {n}
          </span>
        ))}
      </span>
    </span>
  );
}

export function SplitFlapNumber({ value, size = 72, color = "var(--cream)", weight = 900 }: Props) {
  return (
    <span className="flap" style={{ fontSize: size, color, lineHeight: 1, fontWeight: weight }}>
      {[...value].map((ch, i) =>
        /\d/.test(ch) ? (
          <Digit key={`d${i}`} d={Number(ch)} />
        ) : (
          <span key={`s${i}`} style={{ lineHeight: "1em" }}>
            {ch}
          </span>
        ),
      )}
    </span>
  );
}
